
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loja",
      function () {
        return require("private-next-pages/loja/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loja"])
      });
    }
  